module.exports = __webpack_public_path__ + "img/btn-plus-alone.4527ecaa.png";